<app-spinner *ngIf="isLoading"></app-spinner>
<div class="processing" *ngIf="isLoading && !imageLoading">
  <h4>Procesando datos...</h4>
</div>
<div class="processing" *ngIf="isLoading && imageLoading">
  <h4>Procesando imágenes...</h4>
  <h5>Si son grandes, pueden tardar unos segundos...</h5>
</div>

<div class="edited" *ngIf="!isLoading && edited">
  <ngb-alert [type]="'success'" *ngIf="errorMessage">
    {{ errorMessage }}
  </ngb-alert>
  <h5 class="pt-5 pb-3">
    Volviendo automáticamente al listado en <strong>3 segundos</strong>...
  </h5>

  <div class="pt-5">
    <a (click)="onNavigate('this')" class="btn btn-lg btn-block btn-light">
      <i class="fa fa-pencil" aria-hidden="true"></i>&nbsp;&nbsp;Revisar la
      nevera
    </a>
  </div>
</div>

<div class="card" class="card" *ngIf="!isLoading && !edited">
  <div class="card-header" *ngIf="mode === 'create'">Nueva nevera</div>
  <div class="card-header" *ngIf="mode === 'edit'">Editar nevera</div>
  <div class="card-body">
    <form (submit)="onSubmit(editForm)" #editForm="ngForm">
      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="mb-3">
            <label class="form-label">
              Fecha: <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <input
                class="form-control input-calendar"
                name="nevera_date_full"
                [(ngModel)]="nevera.nevera_date_full"
                ngbDatepicker
                #d="ngbDatepicker"
                (click)="d.toggle()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary fa fa-calendar"
                  (click)="d.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>

          <div class="mb-3" *ngIf="tipo && nevera.nevera_date_full">
            <label class="form-label">
              URL amigable:
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                placement="top"
                ngbTooltip="Mejora el posicionamiento en buscadores. Debe ser única."
              ></i>
            </label>
            <input
              type="text"
              class="form-control"
              [value]="processURLSlug()"
              disabled
            />
          </div>

          <label>
            Fotografías de la nevera:
            <i
              class="fa fa-info-circle"
              aria-hidden="true"
              placement="top"
              ngbTooltip="Se debe incluir al menos una imagen en formato JPG o PNG. Es posible pulsar y arrastrar para modificar el orden de visualización."
            >
            </i>
            &nbsp;<span class="text-danger">*</span>
          </label>

          <div dragula="images" [(dragulaModel)]="nevera.images">
            <div *ngFor="let image of nevera.images; let i = index">
              <div class="row ingrediente imagen">
                <div class="col-md-7 col-sm-12 col-xs-12">
                  <button
                    class="btn btn-light btn-image"
                    type="button"
                    (click)="imagePicker.click()"
                  >
                    <i class="fa fa-picture-o" aria-hidden="true"></i>&nbsp;
                    <span *ngIf="nevera.images[i] && nevera.images[i].preview"
                      >Reemplazar</span
                    ><span
                      *ngIf="!nevera.images[i] || !nevera.images[i].preview"
                      >Seleccionar</span
                    >
                  </button>
                  <input
                    type="file"
                    accept="image/x-png,image/jpeg"
                    #imagePicker
                    (change)="onImagePicked($event, i)"
                    id="imagePicker_{{ i }}"
                  />

                  <span class="btn btn-light" (click)="onDeleteImagen(i)"
                    ><i class="fa fa-trash-o"></i>
                    &nbsp;&nbsp;Eliminar
                  </span>
                </div>

                <div class="col-md-4 col-sm-12 col-xs-12 text-right">
                  <a
                    *ngIf="
                      nevera &&
                      nevera.images[i] &&
                      nevera.images[i].preview &&
                      nevera.images[i].preview.includes('http')
                    "
                    target="_blank"
                    href="{{ nevera.images[i].preview }}"
                  >
                    <img
                      src="{{
                        nevera.images[i].preview.replace(
                          '/images/',
                          '/images/l-'
                        )
                      }}"
                      [alt]="editForm.value.nevera_description"
                      class="img-thumbnail"
                    />
                  </a>
                  <img
                    *ngIf="
                      nevera &&
                      nevera.images[i] &&
                      nevera.images[i].preview &&
                      !nevera.images[i].preview.includes('http')
                    "
                    src="{{ nevera.images[i].preview }}"
                    [alt]="editForm.value.nevera_description"
                    class="img-thumbnail"
                  />

                  <!--<label class="btn btn-default file-input">
          Arrastrar o seleccionar <input type="file" hidden />
        </label>-->
                </div>

                <div class="col-md-1 col-sm-12 col-xs-12 text-center">
                  <i class="fa fa-sort" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
          <button
            class="btn btn-light btn-add"
            *ngIf="this.nevera.images"
            [disabled]="!nevera.images[this.nevera.images.length - 1].preview"
            (click)="onAddImagen()"
          >
            <i class="fa fa-plus-circle"></i>&nbsp;&nbsp;Añadir otra imagen
          </button>
        </div>

        <div class="col-md-5 col-sm-5 col-xs-12 right-column">
          <div class="mb-3">
            <br />
            <div
              class="btn btn-success btn-block"
              id="getCoordinatesBtn"
              (click)="getCoordinates(null)"
            >
              <i class="fa fa-cog"></i>&nbsp;&nbsp;Extraer ubicación de las
              imágenes
            </div>
            <br />
            <div class="row">
              <div class="col-md-6">
                <label>Latitud GPS:</label>
                <input
                  type="text"
                  class="form-control"
                  name="latitud"
                  [ngModel]="nevera.latitud"
                  placeholder="Especificar latitud..."
                />
              </div>
              <div class="col-md-6">
                <label>Longitud GPS:</label>
                <input
                  type="text"
                  class="form-control"
                  name="longitud"
                  [ngModel]="nevera.longitud"
                  placeholder="Especificar longitud..."
                />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-6">
                <label>Localidad:</label>
                <input
                  type="text"
                  class="form-control"
                  name="ciudad"
                  [ngModel]="nevera.ciudad"
                  placeholder="Especificar localidad..."
                />
              </div>
              <div class="col-md-6">
                <label>País:</label>
                <input
                  type="text"
                  class="form-control"
                  name="pais"
                  [ngModel]="nevera.pais"
                  placeholder="Especificar país..."
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-sm-3 col-xs-12">
          <img
            class="nevera-img"
            [style.opacity]="
              !(
                !nevera.images ||
                nevera.images.length === 0 ||
                !nevera.images[this.nevera.images.length - 1].preview
              )
                ? '0'
                : '.8'
            "
            src="../../../assets/img/nevera-empty.png"
          />
          <img
            class="nevera-img"
            [style.opacity]="
              !nevera.images ||
              nevera.images.length === 0 ||
              !nevera.images[this.nevera.images.length - 1].preview
                ? '0'
                : '.8'
            "
            src="../../../assets/img/nevera-full.png"
          />
        </div>

        <div class="col-md-12 save">
          <button
            type="submit"
            class="btn btn-success"
            id="submitBtn"
            [disabled]="
              editForm.invalid ||
              nevera.nevera_date_full == '' ||
              !nevera.images ||
              nevera.images.length === 0 ||
              !nevera.images[this.nevera.images.length - 1].preview
            "
          >
            <i class="fa fa-floppy-o" aria-hidden="true"></i>&nbsp;&nbsp;Guardar
          </button>
          <p
            *ngIf="
              !editForm.pristine &&
              (editForm.invalid ||
                nevera.nevera_date_full == '' ||
                !nevera.images ||
                nevera.images.length === 0 ||
                !nevera.images[this.nevera.images.length - 1].preview)
            "
            class="text-danger"
          >
            * Para guardar,<br />rellene todos los<br />campos obligatorios
          </p>
        </div>
      </div>
    </form>
  </div>
</div>
